define(
  'app/views/kala_featured_list',['app/setup'],
  function(takhfifan) {

    takhfifan.KalaFeaturedList = Backbone.View.extend({

      initialize: function(options) {
        var $sortOptions = this.$el.find('.tkh-sort-options'),
            _this = this;
        $sortOptions.find('li').click(function(){
          var $this = $(this);
          $this.parent('ul').find('li').toggleClass('active');
          if($this.data('sorted') === false){
            _this.$el.removeClass('kala-featured-list--sorted');
          }else{
            _this.$el.addClass('kala-featured-list--sorted');
          }
        })
      }

    });
  });

